import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const BasicInformationPage = loadable(
  async () =>
    import("~/features/base-information/pages/BasicInformationPage"),
  { fallback: <></> },
)

export const baseInformationRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.basicInformation,
    element: <BasicInformationPage />,
  },
]
